import React from 'react';
import { cn } from '@express-labs/raven-tools';
import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const Visa: React.FC<IconV1Props> = ({ icon }) => (
  <svg
    className={cn(s.svg, 'svg-icon--visa')}
    viewBox="0 0 120 75.4"
    xmlns="http://www.w3.org/2000/svg"
    data-icon={icon}
  >
    <g>
      <path
        d="M6.4 0h107.2c3.5 0 6.4 2.9 6.4 6.4V69c0 3.5-2.9 6.4-6.4 6.4H6.4C2.9 75.4 0 72.5 0 69V6.4C0 2.9 2.9 0 6.4 0z"
        fill="#0E4595"
      />
      <path
        d="M44.5 53.5l5.3-31.3h8.5L53 53.5h-8.5zm39.4-30.7c-1.7-.6-4.3-1.3-7.7-1.3-8.4 0-14.4 4.2-14.4 10.3 0 4.5 4.2 7 7.5 8.5s4.4 2.5 4.4 3.9c0 2.1-2.7 3.1-5.1 3.1-3.4 0-5.2-.5-8-1.6l-1.1-.5-1.2 7c2 .9 5.7 1.6 9.5 1.7 9 0 14.8-4.2 14.9-10.7 0-3.6-2.2-6.3-7.2-8.5-3-1.4-4.8-2.4-4.8-3.9 0-1.3 1.5-2.7 4.9-2.7 2.8 0 4.8.6 6.4 1.2l.8.4 1.1-6.9m22-.6h-6.6c-2 0-3.6.6-4.5 2.6L82.1 53.5h9s1.5-3.9 1.8-4.7h10.9c.3 1.1 1 4.7 1 4.7h7.9c.1 0-6.8-31.3-6.8-31.3zM95.4 42.4c.7-1.8 3.4-8.8 3.4-8.8-.1.1.7-1.8 1.1-3l.6 2.7s1.6 7.5 2 9h-7.1zM37.3 22.2l-8.4 21.4-.9-4.4c-1.6-5-6.4-10.4-11.8-13.1l7.6 27.4h9l13.4-31.3h-8.9"
        fill="#FFFFFF"
      />
      <path
        d="M21.1 22.2H7.3l-.1.7C17.9 25.4 25 31.7 28 39.2l-3-14.4c-.5-2-2-2.6-3.9-2.6"
        fill="#F2AE14"
      />
    </g>
  </svg>
);

export default Visa;
